import { Repository } from "../../adapters/repository";
import { IconExtractor } from "../../adapters/iconExtractor";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(
  repository: Repository,
  extractor: IconExtractor,
): Interactor {
  return (project) =>
    present(
      repository
        .getProjectExternalLinks(project)
        .then((links) =>
          links.map((link) =>
            extractor.extractIcon(link).then((icon) => ({ ...link, icon })),
          ),
        )
        .then((promises) => Promise.all(promises))
        .then((links) => ({ project, links }))
        .catch(() => Promise.reject(project)),
    );
}

export type { Interactor };

export { createInteractor };
